import script from "./DirectKomplettpaket.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectKomplettpaket.vue?vue&type=script&setup=true&lang=js"

import "./DirectKomplettpaket.vue?vue&type=style&index=0&id=adacb1ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adacb1ec"]])

export default __exports__